import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import { Area } from '@/enums/Area.enum';
import { LayerName } from '@/enums/LayerName.enum';
import { Style } from 'ol/style';
import { FILL_TRANSPARENT, STROKE_WHITE_W05 } from '@/utils/constants.utils';

import data from '@/data/grid.data.json';

const style = new Style({
	fill: FILL_TRANSPARENT,
	stroke: STROKE_WHITE_W05,
});

export const gridLayer = new VectorLayer({
	visible: true,
	source: new VectorSource({
		features: new GeoJSON().readFeatures(data, { featureProjection: 'EPSG:3857' }),
	}),
	style,
});

gridLayer.setProperties({ area: Area.GRID10KM, name: LayerName.GRID });
